import { AcademicProfessionalAssociation } from '../types';
import { Result } from '..';
import { Observable } from 'rxjs';

export abstract class ProfileService {
    public abstract getAcademicProfessionalAssociations(): Observable<AcademicProfessionalAssociation[]>;
    public abstract SaveAcademicProfessionalAssociations(academicProfessionalAssociations: AcademicProfessionalAssociation[]): Promise<Result<null,string>>;
    public abstract loadAcademicProfessionalAssociations(): void;
}
